import axios from 'axios';

const TOKEN_KEY = 'izm.token';

export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * `useApi` is true when an API base URL has been configured. When false, the
 * app stays in mock-data mode (handy for local design work without running
 * the Spring backend). Pages that strictly need the backend (Roles, Audit,
 * etc.) show an empty state explaining how to configure it.
 */
export const useApi = Boolean(API_BASE_URL);

export const api = axios.create({
  baseURL: API_BASE_URL || '/',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let onUnauthorized = null;
export function setUnauthorizedHandler(fn) {
  onUnauthorized = fn;
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 && onUnauthorized) {
      onUnauthorized();
    }
    return Promise.reject(normalizeError(error));
  }
);

export function normalizeError(error) {
  const response = error?.response?.data;
  return {
    status: error?.response?.status,
    message: response?.message || error?.message || 'Request failed',
    validationErrors: response?.validationErrors,
    raw: error,
  };
}

/** Unwraps ApiResponse<T> envelopes returned by the backend. */
export function unwrap(promise) {
  return promise.then((res) => res?.data?.data ?? res?.data);
}
